import { Locales } from "i18n"
import { RootState } from "state/store"

export const getAppLocale = (state: RootState): Locales => {
  return state.appReducer.locale
}
